import { useRef, useState } from "react";
import ReactQuill from "react-quill";
import { quillFormats, quillModules } from "../../constant";

export default function TextEditor({ newChecklist, setNewChecklist }) {
  const [charCount, setCharCount] = useState(0);
  const quillRef = useRef(null);
  const CHARACTER_LIMIT = 1500;

  const handleChange = (html, delta, source, editor) => {
    const text = editor.getText();
    const textLength = text.trim().length;

    if (textLength <= CHARACTER_LIMIT) {
      setNewChecklist(html);
      setCharCount(textLength);
    } else {
      // If user tries to exceed limit, show warning and revert
      if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        quill.root.innerHTML = newChecklist;
      }
    }
  };

  return (
    <>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={newChecklist}
        onChange={handleChange}
        modules={quillModules}
        formats={quillFormats}
      />
      <div style={{ textAlign: "right", fontSize: "14px" }}>
        {charCount} / 1500
      </div>
    </>
  );
}
